export const checkbox = theme => ({
	root: {
		display: "block"
	},
	formControl: {
		padding: 0
	},
	group: {
		margin: `${theme.spacing.unit}px 0`
	},
	action: {
		"&:last-child": {
			margin: 0
		},
		"&:hover": {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.common.white
		},
		"&:active, &.active": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.common.white
		},
		width: 35,
		height: 35,
		margin: `0 ${theme.spacing.unit}px 0 0`,
		borderRadius: "100%",
		fontSize: "0.75rem",
		minHeight: 1,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[3],
		"& span": {
			margin: "auto"
		},
		"&:hover span, &:active span, &.active span": {
			color: theme.palette.common.white
		},
		"@media (max-width:1440px)": {
			width: 24,
			height: 24
		},
		"@media (max-width:960px)": {
			width: 35,
			height: 35
		}
	},
	colored: {
		backgroundColor: theme.palette.background.paper,
		"&$action:nth-child(1):hover,&$action:nth-child(1):active,&$action:nth-child(1).active": {
			backgroundColor: theme.app.backgroundColor1
		},
		"&$action:nth-child(2):hover,&$action:nth-child(2):active,&$action:nth-child(2).active": {
			backgroundColor: theme.app.backgroundColor2
		},
		"&$action:nth-child(3):hover,&$action:nth-child(3):active,&$action:nth-child(3).active": {
			backgroundColor: theme.app.backgroundColor3
		},
		"&$action:nth-child(4):hover,&$action:nth-child(4):active,&$action:nth-child(4).active": {
			backgroundColor: theme.app.backgroundColor4
		},
		"&$action:nth-child(5):hover,&$action:nth-child(5):active,&$action:nth-child(5).active": {
			backgroundColor: theme.app.backgroundColor5
		},
		"&$action:nth-child(n + 6):hover,&$action:nth-child(n + 6):active,&$action:nth-child(n + 6).active": {
			backgroundColor: theme.palette.primary.main
		}
	},
	colorWhite: {
		color: `${theme.palette.common.white} !important`,
		fontSize: "1rem",
		textTransform: "capitalize"
	},
	icon: {
		padding: theme.spacing.unit
	}
});
export const radio = theme => ({
	action: {
		"&:last-child": {
			margin: 0
		},
		"&:hover": {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.common.white
		},
		"&:active, &.active": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.common.white
		},
		"&.all": {
			textTransform: "capitalize"
		},
		width: 35,
		height: 35,
		margin: `0 ${theme.spacing.unit}px 0 0`,
		borderRadius: "100%",
		fontSize: "0.75rem",
		minHeight: 1,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[3],
		"& span": {
			margin: "auto"
		},
		"&:hover span, &:active span, &.active span": {
			color: theme.palette.common.white
		}
	},
	colored: {
		backgroundColor: theme.palette.background.paper,
		"&$action:nth-child(1):hover,&$action:nth-child(1):active,&$action:nth-child(1).active": {
			backgroundColor: theme.app.backgroundColor1
		},
		"&$action:nth-child(2):hover,&$action:nth-child(2):active,&$action:nth-child(2).active": {
			backgroundColor: theme.app.backgroundColor2
		},
		"&$action:nth-child(3):hover,&$action:nth-child(3):active,&$action:nth-child(3).active": {
			backgroundColor: theme.app.backgroundColor3
		},
		"&$action:nth-child(4):hover,&$action:nth-child(4):active,&$action:nth-child(4).active": {
			backgroundColor: theme.app.backgroundColor4
		},
		"&$action:nth-child(5):hover,&$action:nth-child(5):active,&$action:nth-child(5).active": {
			backgroundColor: theme.app.backgroundColor5
		},
		"&$action:nth-child(n + 6):hover,&$action:nth-child(n + 6):active,&$action:nth-child(n + 6).active": {
			backgroundColor: theme.palette.primary.main
		}
	},
	colorWhite: {
		color: `${theme.palette.common.white} !important`,
		fontSize: "1rem",
		textTransform: "capitalize"
	},
	icon: {
		padding: theme.spacing.unit
	}
});
export const range = theme => ({
	root: {
		display: "flex",
		flexDirection: "column",
		"&:before": {
			content: "( !important)"
		}
	},
	wrapper: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		"&:before": {
			content: "( !important)"
		}
	},
	textField: {
		backgroundColor: theme.palette.common.white,
		fontSize: "0.75rem",
		color: theme.palette.common.black,
		padding: `0px ${theme.spacing.unit / 2}px`,
		width: "100%",
		borderRadius: theme.spacing.unit * 10,
		marginRight: theme.spacing.unit * 2,
		marginTop: theme.spacing.unit,
		"&:last-child": {
			marginRight: 0
		}
	},
	adorment: {
		marginRight: theme.spacing.unit / 4,
		marginLeft: theme.spacing.unit / 4,
		fontSize: "0.7rem",
		"&:before": {
			content: ""
		}
	}
});

export const slider = theme => ({
	customRoot: {
		marginTop: "-2rem",
		[theme.breakpoints.down("sm")]: {
			height: "8rem"
		}
	},
	customThumb: {
		color: "rgb(230,0,126)",
		borderRadius: "0rem",
		transform: "rotate(45deg)",
		marginBottom: "0.188rem !important",
		marginLeft: "-0.39rem !important",
		"&:hover, &:focus": {
			boxShadow: "0px 0px 0px 1px rgba(255, 189, 84, 0.16) !important"
		},
		[theme.breakpoints.down("sm")]: {
			marginBottom: "0.125rem !important"

		}
	},
	customTrack: {
		backgroundColor: "rgba(230,0,126,0.8)",
		width: "0.06rem",
		[theme.breakpoints.down("sm")]: {
			backgroundColor: "rgba(230,0,126,0.6)"
		}
	},
	customRail: {
		color: "rgba(0,0,0,0.8)",
		width: "0.12rem !important",
		margin: "0px !important",
		height: "0rem !important",
		[theme.breakpoints.down("sm")]: {
			width: "1px",
			margin: "2px !important"
		}
	},
	customMarks: {
		height: "1rem",
		width: "1rem",
		transform: "rotate(45deg)",
		right: "0.55rem",
		backgroundColor: "rgba(0,0,0,1)",
		opacity: "1",
		border: "0.063rem solid black",
		[theme.breakpoints.down("sm")]: {
			height: "0.8rem",
			width: "0.8rem",
			right: "0.4rem",
			margin: "2px"
		}
	},
	customVertical: {
		height: "20rem !important",
		padding: "0 1rem !important",
		[theme.breakpoints.down("sm")]: {
			height: "16rem !important",
			padding: "0 0.5rem"
		}
	},
	customLabel: {
		transform: "translateY(15%) !important",
		paddingLeft: "10px",
		left: "2rem !important",
		color: "white",
		[theme.breakpoints.down("sm")]: {
			transform: "translateY(10%) !important"
		}
	}
});
export const filter = theme => ({
	wrapper: {
		display: "flex",
		width: "inherit",
		"&.mobile $hiddenMobile": {
			display: "inline-flex"
		}
	},
	icon: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing.unit,
		color: theme.palette.primary.main,
		fill: theme.palette.primary.main,
		fontSize: 30,
		width: 22,
		height: 22
	},
	name: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing.unit,
		textTransform: "uppercase",
		color: "#000000"
	},
	hiddenMobile: {
		display: "none"
	},
	actions: {
		display: "block",
		alignItems: "center",
		// borderRadius: theme.spacing.unit * 12,
		padding: theme.spacing.unit / 2,
		backgroundColor: "transparent",
		width: "100%"
	},
	withBackground: {
		//backgroundColor: theme.palette.background.paper
		//padding: "20px"
	},
	[theme.breakpoints.down("sm")]: {
		drawer: {
			width: "100vw"
		},
		drawerPaper: {
			width: "100vw"
		},
		actions: {
			justifyContent: "left",
			// borderRadius: 20,
			textAlign: "left",
			width: "100%"
		}
	}
});

export default {
	checkbox,
	radio,
	range,
	slider,
	filter
};
